import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';

/**
 *  Describe the component
 *
 */
function FilterTitle(_ref) {
  let {
    title,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("span", Object.assign({
    "data-cmp": "filterTitle"
  }, rest), /*#__PURE__*/_jsx("h2", {
    className: "col-xs-12 text-bold text-gray-base text-size-300 text-size-sm-400"
  }, void 0, title));
}
export default FilterTitle;